import { Component, inject, type OnInit, signal } from '@angular/core';
import { FinoCommonModule } from '@fino-ui/common';
import { FinoTranslationModule } from '@fino-ui/translation';
import { merge } from 'lodash';
import { Subscription } from 'rxjs';
import { NavbarService } from '../../components/navbar/navbar.service';
import { IdentifyDocumentComponent } from '../identify-document/identify-document.component';
import { IdentifyDocumentService } from '../identify-document/identify-document.service';
import { ClarificationService } from './clarification.service';

@Component({
  selector: 'app-clarification',
  templateUrl: './clarification.component.html',
  styleUrls: ['./clarification.component.sass'],
  imports: [FinoCommonModule, IdentifyDocumentComponent, FinoTranslationModule],
})
export class ClarificationComponent implements OnInit {
  private readonly clarificationService = inject(ClarificationService);
  private readonly identifyDocumentService = inject(IdentifyDocumentService);
  private readonly navbarService = inject(NavbarService);

  public clarificationJobs = signal<any[]>([]);
  public selectedJob = signal<any>(undefined);
  public selectedJobId = signal('');
  public selectedJobPreviousJobId = signal('');
  public jobSubscription: Subscription = Subscription.EMPTY;
  public clarificationSubscription: Subscription = Subscription.EMPTY;

  public isUpgrightDisplay = signal(false);

  ngOnInit() {
    this.loadClarificationJobs();

    this.navbarService.toggleUpright.subscribe((toggleUpright) => {
      this.isUpgrightDisplay.set(toggleUpright);
    });
  }

  loadClarificationJobs() {
    this.clarificationSubscription = this.clarificationService
      .loadClarificationJobs()
      .subscribe((res) => {
        this.clarificationJobs.set(res as any[]);
      });
  }

  selectJob(job: any) {
    this.selectedJobId.set(job.id);
    this.selectedJobPreviousJobId.set(job.previousJobId);
    this.jobSubscription = this.identifyDocumentService
      .fetchNextJob(job.previousJobId)

      .subscribe({
        next: (result) => {
          if (!result) {
            this.selectedJob.set(
              merge(job, {
                envelope: {
                  tenant: job.tenant,
                  documentType: '',
                  oldIban: job.oldIban,
                  newIban: job.newIban,
                  rejectionReason: '',
                  rejectionReasonText: '',
                },
              }),
            );
            return;
          }
          this.selectedJob.set(result);
        },
      });
  }
}
